import { FINANCE_PAGE_LABELS, type FinancePage } from "../lib/finance";
import { useStore } from "../store";

const PAGES: FinancePage[] = ["payout", "taxes", "deferred"];

/** The report's three pages. They share one slicer state, as in Power BI. */
export function PageTabs() {
  const page = useStore((s) => s.page);
  const setPage = useStore((s) => s.setPage);

  return (
    <div className="preset-tabs" role="tablist" aria-label="Report pages">
      <span className="preset-group">Financial Rep</span>
      {PAGES.map((p) => (
        <button
          key={p}
          role="tab"
          aria-selected={page === p}
          className={`preset-tab ${page === p ? "active" : ""}`}
          onClick={() => setPage(p)}
        >
          {FINANCE_PAGE_LABELS[p]}
        </button>
      ))}
    </div>
  );
}
